export default __webpack_public_path__ + "5159c958b521d1da1c3074b5f1119198.png";